import React from 'react';
import PropTypes from 'prop-types';
import RequiredMark from 'shared/inputs/RequiredMark';
import get from 'lodash/get';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const FormikTextarea = ({
  label, wrapperClass, value, errors, touched, touchedNested = false, ...inputProps
}) => {
  const hasError = get(errors, inputProps.name) && (touchedNested || get(touched, inputProps.name));
  return (
    <div className={`formik-wrapper ${wrapperClass || ''}`}>
      <label htmlFor={inputProps.name}>
        {label}
        {inputProps.required ? <RequiredMark /> : null}
      </label>
      <textarea className={`input ${hasError ? 'error' : ''}`} id={inputProps.name} {...inputProps} value={value === null ? '' : value} />
      {hasError && <div className='feedback'>{get(errors, inputProps.name)}</div>}
    </div>
  );
};

FormikTextarea.propTypes = {
  label: PropTypes.string,
  inputProps: PropTypes.object,
  wrapperClass: PropTypes.string,
};

export default FormikTextarea;
